import React from "react";
import Accordion from "../../common/Accordion/Accordion";
import styles from "./FAQs.module.scss";

const FAQs = () => {
  const faqs = [
    {
      id: 1,
      question: "What is EMIfy?",
      answer:
        "EMIfy is an automated payment reconciliation platform designed to help businesses and vendors collect payments from their customers seamlessly. It offers features like real-time payment tracking, automated collections, and secure e-Mandate management.",
    },
    {
      id: 2,
      question: "How does EMIfy work?",
      answer:
        "EMIfy works by enabling businesses to create secure e-Mandates that allow automatic payment deductions from customers' bank accounts. It integrates with over 200+ banks and UPI apps, automating the entire payment collection and reconciliation process without manual intervention.",
    },
    {
      id: 3,
      question: "What makes EMIfy different from other payment collection platforms?",
      answer: `
        EMIfy stands out with:
        • Zero-Commission Business Model
        • AI-Driven Reconciliation & Analytics
        • Customizable Payment Plans
        • Real-Time Transaction Tracking
        • Secure E-Mandate Creation with NPCI Compliance
      `,
    },
    {
      id: 4,
      question: "Is EMIfy safe and secure for handling payments?",
      answer:
        "Yes, EMIfy prioritizes security by using end-to-end encryption and following regulatory standards, including NPCI guidelines and PCI DSS compliance. All transactions are securely processed through trusted banking networks.",
    },
    {
      id: 5,
      question: "Can I use EMIfy for recurring payments?",
      answer:
        "Absolutely! EMIfy specializes in recurring payments through its e-Mandate system, making it ideal for businesses like subscription services, loan collections, and service-based businesses requiring monthly payments.",
    },
    {
      id: 6,
      question: "How do I create an e-Mandate for my customers?",
      answer: `
        You can create an e-Mandate in three simple steps:
        1. Enter Customer Details (Name, Payment Amount, Frequency)
        2. Generate & Share the Mandate Link via SMS, WhatsApp, or Email
        3. Customer Authorizes the Mandate through their preferred bank or UPI app
      `,
    },
    {
      id: 7,
      question: "Does EMIfy integrate with accounting software?",
      answer:
        "Yes, EMIfy offers seamless integrations with popular accounting software like Tally, QuickBooks, and Zoho Books. Additionally, our REST APIs and SDKs allow custom integrations with CRMs and ERPs.",
    },
    {
      id: 8,
      question: "What payment methods does EMIfy support?",
      answer: `
        EMIfy supports multiple payment options, including:
        • UPI Apps
        • Net Banking
        • Debit & Credit Cards
        • Wallets & Bank Transfers
      `,
    },
    {
      id: 9,
      question: "How does EMIfy help with payment reconciliation?",
      answer:
        "EMIfy automates payment reconciliation by matching received payments with invoices in real time. It provides detailed transaction reports and flags any discrepancies for faster resolution.",
    },
    {
      id: 10,
      question: "Can EMIfy be used for both small businesses and enterprises?",
      answer:
        "Yes! EMIfy is scalable and offers flexible pricing plans for businesses of all sizes, from small retailers to large enterprises managing high transaction volumes.",
    },
    {
      id: 11,
      question: "How can I get started with EMIfy?",
      answer: `
        Getting started with EMIfy is simple:
        1. Sign Up on the EMIfy platform
        2. Create a Business Profile
        3. Set Up Payment Preferences
        4. Start Collecting Payments Automatically
      `,
    },
  ];
  

  return (
    <section className={styles.faqs} id="faqs">
    <h2>Got Questions? We’ve Got <span>Answers.</span></h2>
    <div className={styles.accordions}>
      {faqs.map((faq, index) => (
        <Accordion key={index} index={index} question={faq.question} answer={faq.answer} />
      ))}
    </div>
  </section>
  );
};

export default FAQs;
